<template>
    <v-dialog v-model="showDialog" max-width="500px" scrollable>
        <v-card v-if="product">
            <v-card-title class="headline align-start flex-column pa-2 primary primarytext--text">
                <div class="font-weight-bold fill-width">
                    <span v-text="product.name" />
                    <v-btn icon @click="showDialog = false" class="float-right"><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                </div>
            </v-card-title>
            <v-card-text>

                <v-row>
                    <v-col md=6 cols=12>
                        <v-auto-img :src="product.imagekey" height="200px"></v-auto-img>
                    </v-col>
            
                    <v-col md=6 cols=12>
                        <div
                            ref="description"
                            v-html="product.description"
                            :class="{'z-fade-to-white': !showFullDescription && !checkHeight}"
                            :style="{'height': checkHeight ? 'unset' : (showFullDescription ? 'unset' : '200px'), 'overflow': 'hidden' }"
                        />

                        <div class="d-flex" v-if="!showFullDescription">
                            <hr class="v-divider theme--light flex-grow-1" :style="{'margin-top': (showMoreButtonHeight/2) + 'px'}" />

                            <zoezi-button :radius="'20px'" :text="$translate('Show more')" icon="mdi-chevron-down" thin right text-color="#999" color="white" @click="showFullDescription = true"  style="font-size: 0.8em; padding: 0px 10px; height: 20px" />

                            <hr class="v-divider theme--light flex-grow-1" :style="{'margin-top': (showMoreButtonHeight/2) + 'px'}" />

                        </div>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions v-if="showBuyButton" class="d-block">
                <div class="d-flex flex-row">
                    <v-spacer />
                    <span class="primary--text font-weight-bold">{{priceString}}</span>
                </div>
                <div class="d-flex flex-row align-center">
                    <v-spacer />

                    <div><v-select style="width: 150px" label="Varianter" :items="variants" item-text="name" item-value="name" v-model="variant" v-if="hasVariants" /></div>

                    <div v-if="showCount"><product-count v-model="count" /></div>

                    <checkout-button
                        @click.native.stop=""
                        v-if="useCheckoutButton"
                        :component="{component: 'zoezi-button', props: {text: $translate(buyButtonText), thin: true}}"
                        :products="[{product_id: product.id, count: 1}]"
                        @showCheckout="showCheckout => { if (!showCheckout) $emit('buy', {variant, count}) }"
                    />

                    <zoezi-button v-else @click="buy" thin :text="$translate(buyButtonText)" :disabled="!canBuy" />

                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Vue from 'vue'
import ProductCount from './ProductCount.vue';
import CheckoutButton from '../views/CheckoutButton.vue'
import {getPriceString} from '../util.js'
export default {
    name: 'zoezi-product-dialog',

    props: {
        value: {
            type: Boolean
        },
        showCount: {
            type: Boolean,
            default: true
        },
        product: {
            type: Object
        },
        basket: {
            type: Array
        },
        showBuyButton: {
            type: Boolean,
            default: true
        },
        buyButtonText: {
            type: String,
            default: 'Buy'
        },
        useCheckoutButton: {
            type: Boolean,
            default: false
        }
    },

    components: {
        ProductCount,
        CheckoutButton
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.showDialog = value;
            }
        },
        showDialog(value) {
            this.$emit('input', value);

            if (value) {
                this.show();
            }
        }
    },

    computed: {
        hasVariants() {
            return !(this.variants.length == 1 && this.variants[0].name === null);
        },
        variants() {
            if (!this.product.variants || this.product.variants.length == 0) {
                return [{name: null, stock: this.product.stock}]
            }

            return this.product.variants;
        },
        canBuy() {
            return !this.hasVariants || !!this.variant;
        },
        stock() {
            let variant = this.variants.find(v => v.name == this.variant);
            if (!variant) {
                return 0;
            }
            let stock = variant.stock;
            if (stock != null && this.basket) {
                let bi = this.basket.find(item => item.product_id == this.product.id && variant.name == item.variant);
                if (bi && bi.count) {
                    stock -= bi.count;
                }
                return Math.max(0, stock);
            }

            return stock;
        },
        priceString() {
            return getPriceString(this.product);
        }
    },

    data: () => ({
        showDialog: false,
        count: 1,
        showFullDescription: false,
        checkHeight: true,
        showMoreButtonHeight: 20,
        variant: null
    }),

    methods: {
        doCheck() {
            Vue.nextTick(() => {
                if (!this.$refs.description.scrollHeight) {
                    this.doCheck();
                } else {
                    this.showFullDescription  = this.$refs.description.scrollHeight < 200;
                    this.checkHeight = false;
                }
            });
        },
        show() {
            this.checkHeight = true;
            this.variant = this.variants[0].name;
            this.count = 1;
            if (!this.product.description) {
                this.checkHeight = false;
                this.showFullDescription = true;
            } else {
                this.doCheck();
            }
        },
        buy() {
            if (this.stock != null && this.stock < this.count) {
                let text = this.stock > 0 ? `Det finns bara ${this.stock} av denna produkt i lager` : 'Det finns inga produkter kvar i lager';
                this.$store.commit('showSnackBar', {text});
            } else {
                this.$emit('buy', {variant: this.variant, count: this.count})
                this.showDialog = false;
            }
        }
    }
}
</script>